export default __webpack_public_path__ + "static/media/not_found.f0b741c3.svg";